





















































































































import Vue from "vue";
import { AjaxPost, Alert } from "../App.vue";
import { GetClientRegistrationURL } from "../../../shared/Shared";
import Client, { validateClient } from "../../../shared/Client";
import CountryCodes from "../../../shared/CountryCodes";

interface CountryRegion {
  region: string;
  name: string;
}

export default Vue.extend({
  name: "Register",
  props: {},
  computed: {
    region: {
      get(): CountryRegion | undefined {
        return this.countryOptions.find((p) => p.region === this.client.region);
      },
      set(region: CountryRegion) {
        this.client.region = region.region;
      },
    },

    countryOptions: {
      get(): CountryRegion[] {
        function compare(a: any, b: any) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        }

        const result: CountryRegion[] = [];
        for (const region of Object.keys(CountryCodes)) {
          result.push({
            name: CountryCodes[region],
            region,
          });
        }
        return result.sort(compare);
      },
    },
  },
  methods: {
    Alert(message: string) {
      Alert(message);
    },
    countryLabel(obj: any) {
      if (!obj) {
        return "Select a Country";
      }
      return obj.name;
    },
    submit() {
      try {
        validateClient(this.client);
      } catch (err: unknown) {
        if (err instanceof Error) {
          this.Alert(err.message);
        }
        return;
      }

      AjaxPost(GetClientRegistrationURL(), this.client, false)
        .then(() => {
          this.Alert(
            "Successfully submitted registration request. We'll get back to you in the next few days"
          );
          this.$emit("clicked-cancel");
        })
        .catch((err) => {
          if (err instanceof Error) {
            this.Alert("Error submitting registration request: " + err.message);
          } else {
            this.Alert("Error submitting registration request: " + err);
          }
        });
    },
  },
  data() {
    return {
      client: new Client(),
    };
  },
});
